export interface IModuleTypeModel {
    name: string;
    code: string;
}

export class ModuleTypeModel implements IModuleTypeModel {
    name: string;
    code: string;
    moduleTypeId: number;
}